module.exports = __webpack_public_path__ + "img/hdmi1.61d22b35.jpg";